var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaniumProgress = function SvgTaniumProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 334,
    height: 95,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 93.5,
    height: 93.5,
    x: 0.75,
    y: 0.75,
    stroke: "url(#tanium_progress_svg__a)",
    strokeDasharray: "8 8",
    strokeWidth: 1.5,
    rx: 46.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 93.5,
    height: 93.5,
    x: 239.75,
    y: 0.75,
    stroke: "url(#tanium_progress_svg__a)",
    strokeDasharray: "8 8",
    strokeWidth: 1.5,
    rx: 46.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#tanium_progress_svg__a)",
    strokeDasharray: "11 11",
    strokeWidth: 1.5,
    d: "M97 47.25h140"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#tanium_progress_svg__a)",
    d: "M37.174 38.29v.293l.257.143L62.5 52.687v3.46c0 .054-.03.114-.095.15l-5.121 2.852v-2.82l-.257-.143L31.5 41.97v-2.861c0-.055.03-.115.095-.151l5.58-3.107zM31.602 55.51a.22.22 0 0 1-.102-.19v-7.437l21.525 12.921-6.17 3.67a.18.18 0 0 1-.182 0zM62.416 38.783a.16.16 0 0 1 .084.134v6.226L42.02 33.576l5.451-3.052a.2.2 0 0 1 .19 0zM279.812 44.08h-.5v6.026h8.376000000000001v12.291c-.553.074-1.114.11-1.714.11-8.579 0-15.532-6.955-15.474-15.53v-.003c0-8.52 6.897-15.474 15.474-15.474 7.568 0 13.868 5.391 15.205 12.58z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#tanium_progress_svg__a)",
    d: "M294.67 50.106h6.498c-.822 4.018-3.218 7.46-6.498 9.71z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "tanium_progress_svg__a",
    x1: "0%",
    x2: "200%",
    y1: "50%",
    y2: "50%",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C3CBD4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    dur: "3s",
    repeatCount: "indefinite",
    values: "0.01;0.99;0.01"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3CBD4"
  })))));
};
export default SvgTaniumProgress;